module.exports = {
  "contentAccessControlSettingsView": {
    "name": "pageview",
    "class": "view",
    "namespace": "memberships"
  },
  "contentAccessControl": {
    "name": "Membership settings interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "change access option",
          "enable data wall",
          "disable data wall",
          "update password",
          "update contact lists selection",
          "save access control settings",
          "click navigate to create a list",
          "click navigate to domains & urls",
          "click navigate to private content settings",
          "click blog post read more KB article",
          "click membership registration emails KB article"
        ]
      },
      "access": {
        "type": [
          "public",
          "password",
          "sso",
          "ssoWithLists",
          "listRegistration",
          "selfRegistration"
        ],
        "isOptional": true
      },
      "contentType": {
        "type": "string"
      },
      "isBulk": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "memberships"
  }
};